var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTheGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13556_12354)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13556_12354)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13556_12354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "#6747ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6209 29.3582C21.7751 29.3582 18.6876 26.2707 18.6876 22.4249C18.6876 18.5791 21.7751 15.4916 25.6209 15.4916C29.4668 15.4916 32.5543 18.5791 32.5543 22.4249C32.5543 26.2707 29.4668 29.3582 25.6209 29.3582ZM25.6209 12.0249C31.3626 12.0249 36.0209 16.6832 36.0209 22.4249C36.0209 28.1666 31.3626 32.8249 25.6209 32.8249C19.8793 32.8249 15.2209 28.1666 15.2209 22.4249C15.2209 16.6832 19.8793 12.0249 25.6209 12.0249ZM35.5335 33.3666C36.2376 34.0707 36.2376 35.1541 35.5335 35.8041L28.6001 42.7374C27.896 43.4416 26.8126 43.4416 26.1626 42.7374C25.4585 42.0332 25.4585 40.9499 26.1626 40.2999L33.096 33.3666C33.746 32.6624 34.8835 32.6624 35.5335 33.3666ZM39.5418 13.7582C39.5418 14.7332 38.7835 15.4916 37.8085 15.4916C36.8335 15.4916 36.0751 14.7332 36.0751 13.7582C36.0751 12.7832 36.8335 12.0249 37.8085 12.0249C38.7293 12.0249 39.5418 12.7832 39.5418 13.7582Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13556_12354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13556_12354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13556_12354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheGraph);
export default __webpack_public_path__ + "static/media/The-Graph.d0aac348e765028e7150853b62c73b2e.svg";
export { ForwardRef as ReactComponent };